module.exports = __webpack_public_path__ + "static/img/reset_allonePro.c68ebd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connect/reset_allonePro.png
// module id = 261
// module chunks = 1